import React, { useEffect, useState } from "react";
import heroimg1 from "../assets/bulb.png";
import heroimg2 from "../assets/anime.png";
import useLocalStorage from 'use-local-storage';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Footer1 from "./footer/Footer1";
import { Link } from "react-router-dom";
import BackToTop from "./BackToTop";
import Marque from "./Marque";
import Navbar from "./navbar/Navbar";
import YoutubeSection from "./youtube/YoutubeSection";



function Hero() {

  const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {

            setIsLoading(false);
        },1000);        
    },[])

    const [theme, ] = useLocalStorage('theme' ? 'dark': 'light')

    
  
  useEffect(() => {
    AOS.init();
  },[])   


  return (
    <>
      {
        isLoading ? (<div class="load" data-theme={theme}><hr/><hr/><hr/><hr/></div>): (
          <>
            <Navbar />
            <div className="hero_section text-white py-8 px-16 " >
               
               <div className="mx-auto grid md:grid-cols-2 text-center h-200 items-center md:justify-between">
                  <div data-aos="fade-right" data-aos-duration="1500" className="hero__info">
                   <h4 className=" font-bold font-techFont">Hello, I'm </h4>
                   <h1 className="text-3xl lg:text-6xl font-techFont">
                      <span className="hero__name font-bold text-[var(--text-secondary)] font-techFont">Uchenna Akubue</span>{" "}
                      <br />
                     <span className="hero_role font-techFont">[Software Engineer]</span>
                   </h1>
                   
                   <div className="cta_btn font-bold pt-2">
                     <Link to="/contact">
                        <button id="home_btn_H">Let's Meet</button>
                     </Link>

                     <Link to="/projects">
                        <button id="home_btn_J">My Projects</button>
                     </Link>      
                   </div>
                   
                  </div>
   
                 <div className="hero-image home__img py-8">
                   {
                    theme === "dark" ? (
                      <img
                        src={heroimg1}
                        alt="my__image"
                        className="lgw-[40%] rounded-3xl w-78 pt-8  ml-auto mr-12"
                      />
                    ) : (
                      <img
                        src={heroimg2}
                        alt="my__image"
                        className="lgw-[40%] rounded-3xl w-78 ml-auto mr-12"
                      />
                    )
                   }                   
                 </div>
               </div>
               
            </div>

            <YoutubeSection />
            <Marque />
            <Footer1 />
            <BackToTop />
          </>
        )
      }
    </>
    
  );
}

export default Hero;
